export default __webpack_public_path__ + "static/media/Slide26.79cf3aa0.jpg";